import * as yup from 'yup'

import { FormFields } from './types'

export const validationSchema = yup.object().shape({
  [FormFields.text]: yup
    .string()
    .required()
    .max(100)
    .test(
      'text',
      'Names must be lowercase, and can’t contain spaces, periods, or most punctuation.',
      (value) => {
        if (!value) return true

        return !!value.match(/^[a-z0-9-_]+$/)
      },
    ),
  [FormFields.image]: yup.string().url().required(),
  [FormFields.access]: yup.string().required(),
  [FormFields.tierIds]: yup.array().when([FormFields.access], (access: 'MembersOnly' | 'Plans') => {
    if (access === 'Plans') {
      return yup.array().min(1, 'At least one selected tier is required.')
    }

    return yup.array()
  }),
})
